"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _AbstractPermissionComponent = _interopRequireDefault(require("../components/AbstractPermissionComponent"));

var _utilityFunctions = require("../util/utilityFunctions");

var badArgumentMessage = 'All argument to makeComplexPermissionComponent must be functions';

var _default = function _default() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  (0, _utilityFunctions.invariant)(selectors.reduce(function (functions, selector) {
    return functions && (0, _utilityFunctions.isFunction)(selector);
  }, true), badArgumentMessage);

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _ownProps$disjunct = ownProps.disjunct,
        disjunct = _ownProps$disjunct === void 0 ? false : _ownProps$disjunct;
    return {
      permission: Boolean(selectors && selectors.reduce(function (permission, selector) {
        if (disjunct) {
          return permission || selector(state);
        }

        return permission && selector(state);
      }, !disjunct))
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(_AbstractPermissionComponent.default);
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/permission-components/static-1.43/js/factories/makeComplexPermissionComponent.js
// module id = 661
// module chunks = 209 210 211 212